<template>
  <div>
    <!-- 详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="editTitle"
      :visible.sync="defailDialogVisible"
      :before-close="defailHandleClose"
      width="45%"
      center
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="120px" :rules="rules" :model="form">
        <div class="flexDis itemInp">
          <el-form-item label="分销商简称:" prop="Name">
            <el-input v-model="form.Name" :disabled="disabled" placeholder="请输入简称"></el-input>
            <span v-if="!addRetailvisibleId" style="color:red;font-size:1.4rem;">注: 抖音、快手、美团、携程、去哪儿不可自行添加，可联系技术对接</span>
          </el-form-item>
        </div>
        <el-form-item label="分销商全称:" prop="FullName">
          <el-input v-model="form.FullName" :disabled="disabled" placeholder="请输入分销商全称"></el-input>
        </el-form-item>
        <el-form-item label="第三方系统:">
            <div class="xitong">
              <el-select  :disabled="disabled" @change="slectClick"  v-model="form.third_system" placeholder="请选择分销商所使用的第三方系统">
                  <el-option
                    v-for="item in third"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </div>
        </el-form-item>
        <el-form-item label="地址:" prop="ZoneID">
          <div class="flexDis itemSele">
            <el-select
                v-model="form.ProID"
                placeholder="请选择省"
                :disabled="disabled"
                @change="provinceChange($event)"
              >
                <el-option
                  v-for="item in cityProvince"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                ></el-option>
              </el-select>
            <el-select
                v-model="form.CityID"
                placeholder="请选择市/区"
                @change="cityChange($event)"
                :disabled="disabled"
              >
            
                <el-option
                  v-for="item in cityDistrict"
                  :key="item.cityCode"
                  :label="item.cityName"
                  :value="item.cityCode"
                ></el-option>
              </el-select>
             <el-select v-model="form.ZoneID" :disabled="disabled" placeholder="请选择县/乡">
              <el-option
                v-for="item in cityCounty"
                :key="item.countyCode"
                :label="item.countyName"
                :value="item.countyCode"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="详细地址:" prop="Address">
          <el-input v-model="form.Address" :disabled="disabled" placeholder="请输入详细地址至门牌号"></el-input>
        </el-form-item>
        <div class="flexDis itemMoble" prop="LinkMan">
          <el-form-item label="联系人:">
            <el-input v-model="form.LinkMan"  placeholder="请输入景区联系人姓名"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="联系方式:" prop="Phone">
              <el-input v-model="form.Phone"  placeholder="请输入联系人电话"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flexDis itemMoble">
          <el-form-item label="Email:" prop="E_Mail">
            <el-input v-model="form.E_Mail" :disabled="disabled" placeholder="请输入景区联系人邮箱"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="透支金额:">
              <el-input v-model="form.OverDraftMoney"  placeholder="请输入金额"></el-input>
              <span class="dW">元</span>
            </el-form-item>
          </div>
        </div>
        <div  class="endItem jus flexDis" v-if="retailFlow">
          <div>
            <el-form-item label="退款短信:" prop="refund_sms_flag">
              <el-radio-group v-model="form.refund_sms_flag" :disabled="disabled">
                <el-radio label="1">发送</el-radio>
                <el-radio label="2">不发送</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <!-- <div v-if="retailFlow">
            <el-form-item label="短信设置:" prop="sms_flag">
              <el-radio-group :disabled="disabled"  v-model="form.sms_flag" >
                <el-radio label="2">不发送</el-radio>
                <el-radio label="1">发送</el-radio>
              </el-radio-group>
            </el-form-item>
          </div> -->
        <div :class="form.third_system!='其他'?'sms_flages':''"  >
            <el-form-item label="短信设置:" prop="sms_flag">
              <el-radio-group :disabled="disabled"  v-model="form.sms_flag" @change="SMSch">
                <el-radio label="2">不发送</el-radio>
                <el-radio label="1">发送</el-radio>
                <div :class="status!='1'?'active_raido':''" class="smsFlag_btns" @click="smsChange('1')" v-if="form.third_system!='其他'">
                  {{status=='1'?'去签约':'《短信发送功能服务协议》'}}
                </div>
              </el-radio-group>
            </el-form-item>
          </div>
        <el-form-item class="itemBtnS" >
          <!-- <div class="itm_btns_clear" @click="clearBox">清空</div> -->
          <el-button class="btnL" @click="saveBtns('form')">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="短信发送功能服务协议"
      :visible.sync="agreement"
      :before-close="agreementClose"
      width="52%"
      center
    >
      <el-divider></el-divider>
      <div class="content_css">
        <div>甲方(服务使用方)：贵司</div>
        <div>乙方(服务使用方)：北京金飞鹰科技发展有限公司</div>
        <div>鉴于甲方在拥有第三方提供服务验码的前提下，需再次使用乙方的短信发送功能进行客户服务，双方经友好协商，就短信发送功能服务达成如下协议:</div>
        <div>服务内容：甲方有权通过乙方提供的接口或平台，按照短信内容向指定的手机号码刚发送短信。</div>
        <div>双方权利与义务：甲方应确保第三方服务商对用户下单状态准确性，并承担因第三方下单失异常导致短信发送失误的责任。</div>
        <div>协议解释：1.不发送短信的情况：对于天时、票付通、一机游、爱玩、美团、携程、抖音等平台，为了避免跑单情况，将不发送下单通知短信。</div>
        <div>2.发送短信的情况：对于旅行社等需要使用雪务通分销系统的分销商，可以发送下单短信。</div>
      </div>
      <div class="content_info">
        <el-form class="editForm" ref="form" label-width="120px" :rules="rules" :model="form">
          <div class="flexDis itemMoble">
            <el-form-item label="公司名称：" >
              <el-input v-model="arrs.companyName" placeholder="请输入甲方景区真实有效全称"></el-input>
            </el-form-item>
            <div>
              <el-form-item label="委托人：">
                <el-input v-model="arrs.userName"  placeholder="请输入法人代表或委托人真实有效姓名"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flexDis itemMoble">
            <el-form-item label="身份证号：" >
              <el-input v-model="arrs.idcard" placeholder="法人代表或委托人真实有效的身份证号码"></el-input>
            </el-form-item>
            <div>
              <el-form-item label="联系电话：">
                <el-input v-model="arrs.phone"  placeholder="请输入真实有效联系方式"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div  class="itemBtnS" v-if="statusing!=3">
          <!-- <button>清空</button>
          <div class="btnL">确认添加</div> -->
          <div class="itm_btns_clear" @click="closeArr">清空</div>
          <el-button class="btnL" @click="ArrBtns">确认保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 编辑详情弹框结束 -->
  </div>
</template>

<script>
import {ScenicDisDetail,addDistributor , DisSetPhone , msgAgreement ,getMsgAgreement} from '@/request/scenic.js'
import cityOptions from "@/assets/city.json";
import {Message} from 'element-ui'
export default {
  props:['addRetailvisibleId','OverDraftMoney'],
  data() {
    var checkEmail = (rule,value,cb) => {
        //验证邮箱的正则表达式
        const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        if(regEmail.test(value)){
          //合法的邮箱
          return cb();
        }
        //邮箱不合法
        cb(new Error('请输入合法的邮箱！'));
      }
      //验证手机号的规则
    var checkMobile = (rule,value,cb) =>{
      const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if(regMobile.test(value)){
        //合法的手机号
        return cb();
      }
      //手机号不合法
      cb(new Error('请输入合法的手机号！'));
    }
    return {
      retailFlow:true,
      defailDialogVisible: false, // 详情弹框
      form: {
        Name:'', // 分销商名称
        FullName:'',//分销商全称
        ProID:'',//省id
        CityID:'',// 市id
        ZoneID:'', // 县id
        Address:'', // 地址
        LinkMan:'', // 联系人
        Phone:'', // 手机号
        E_Mail:"",
        OverDraftMoney:'',//透支金额
        Status:'',
        sms_flag:'1',
        refund_sms_flag:'',
        third_system:''
      },
      third:[
        {
          value:'天时同城'
        },
        {
          value:'票付通'
        },
        {
          value:'自我游'
        },
        {
          value:'一机游'
        },
        {
          value:'九天达'
        },
        {
          value:'其他'
        }
      ],
      value: "",
      radio: 1,
      editTitle: "", // 弹框标题
      cityProvince:'',
      cityDistrict:[],
      cityCounty:[],
      rules:{
        E_Mail:[{ required: true, message: '请输入邮箱', trigger: 'blur' },
        {validator: checkEmail, trigger: 'blur'}],
        Name:[{ required: true, message: '请输入分销商简称', trigger: 'blur' }],
        Phone:[{ required: true, message: '请输入分销商手机号', trigger: 'blur' },
        {validator: checkMobile, trigger: 'blur'}],
        FullName:[{ required: true, message: '请输入分销商全称', trigger: 'blur' }],
        ZoneID:[{ required: true, message: '请选择省市区', trigger: 'change' }],
        Address:[{ required: true, message: '请输入分销商地址', trigger: 'blur' }],
        LinkMan:[{ required: true, message: '请输入分销商联系人', trigger: 'blur' }],
        sms_flag:[{ required: true, message: '请选择是否发送短信', trigger: 'change' }]
      },
      disabled:true,
      dianji:false,
      agreement:false,
      arrs:{
        token:window.sessionStorage.getItem('Token'),
        phone:'',
        companyName:'',
        disName:'',
        idcard:'',
        userName:''
      },
      status:'1',
      statusing:''
    };
  },
  created(){
    this.cityProvince = cityOptions;
    this.dianji = false
    if(this.addRetailvisibleId){
      let data = {
        distrbutorid:this.addRetailvisibleId,
        token:window.sessionStorage.getItem('Token'),
      }
      ScenicDisDetail(data).then(res=>{
        if(res.data.status=='yes'){
          this.form = {
            Name:res.data.data.Name, // 分销商名称
            FullName:res.data.data.FullName,//分销商全称
            ProID:res.data.data.ProID  + '',//省id
            CityID:res.data.data.CityID  + '',// 市id
            ZoneID:res.data.data.ZoneID  + '', // 县id
            Address:res.data.data.Address, // 地址
            LinkMan:res.data.data.LinkMan, // 联系人
            Phone:res.data.data.Phone, // 手机号
            E_Mail:res.data.data.E_Mail,
            OverDraftMoney:res.data.data.OverDraftMoney,//透支金额
            Status:res.data.data.Status,
            sms_flag:res.data.data.sms_flag + '',
            refund_sms_flag:res.data.data.refund_sms_flag + '',
            third_system:res.data.data.third_system + ''
          }
          let datas = {
            disName:res.data.data.Name,
            token:window.sessionStorage.getItem('Token'),
          }
          getMsgAgreement(datas).then(res=>{
            if(res.data.status=='ok'){
              this.arrs = {
                token:window.sessionStorage.getItem('Token'),
                phone:res.data.result.phone,
                companyName:res.data.result.companyName,
                disName:'',
                idcard:res.data.result.idcard,
                userName:res.data.result.userName
              }
              this.statusing = 3
            }
          })
          if(res.data.data.third_system!='其他'){
              this.retailFlow = false
              if(res.data.data.sms_flag=='1'){
                this.status = '2'
              }
          }else{
            this.retailFlow = true
            this.form.third_system = '其他'
          }
          this.form.OverDraftMoney = this.OverDraftMoney
           // 省赋值后获取市下拉框对应的值
           this.cityProvince.map((item, index) => {
              if (item.provinceCode == res.data.data.ProID) {
                this.cityDistrict = item.cities;
              }
            });
            // 市赋值后获取县下拉框对应的值
            this.cityDistrict.map((item, index) => {
              if (item.cityCode == res.data.data.CityID) {
                this.cityCounty = item.counties;
              }
            });
          }
      })
    }else{
      this.disabled = false
      this.form={
        Name:'', // 分销商名称
        FullName:'',//分销商全称
        ProID:'',//省id
        CityID:'',// 市id
        ZoneID:'', // 县id
        Address:'', // 地址
        LinkMan:'', // 联系人
        Phone:'', // 手机号
        E_Mail:"",
        OverDraftMoney:'',//透支金额
        Status:'',
        sms_flag:'1',
        refund_sms_flag:'1',
        third_system:'其他'
      }
    }
  },
  methods: {
    ArrBtns(){
      if(this.arrs.phone==''){
        Message.error('请输入联系方式')
        return false
      }else{
        if (/^[1]([3-9])[0-9]{9}$/.test(this.arrs.phone)) {
        } else {
          Message.error('请输入正确手机号')
          return false
        }
      }
      if(this.arrs.companyName==''){
        Message.error('请输入公司名称')
        return false
      }
      if(this.arrs.idcard==''){
        Message.error('请输入身份证号')
        return false
      }else{
        var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
        var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
        if (/^\d{17}\d|x$/i.test(this.arrs.idcard)) {
          var sum = 0, idx;
          for (var i = 0; i < this.arrs.idcard.length - 1; i++) {
            // 对前17位数字与权值乘积求和
            sum += parseInt(this.arrs.idcard.substr(i, 1), 10) * arrExp[i];
          }
          // 计算模（固定算法）
          idx = sum % 11;
          // 检验第18为是否与校验码相等
          if (arrValid[idx] == this.arrs.idcard.substr(17, 1).toUpperCase()) {
          } else {
            Message.error("身份证格式有误")
            return false
          }
        } else {
          Message.error("身份证格式有误")
          return false
        }
      }
      if(this.arrs.userName==''){
        Message.error('请输入委托人姓名')
        return false
      }
      this.arrs.disName = this.form.Name
      msgAgreement(this.arrs).then(res=>{
        if(res.data.status=='ok'){
          Message.success('签约成功')
          this.agreement = false
          this.status = 2
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    closeArr(){
      this.arrs={
        token:window.sessionStorage.getItem('Token'),
        phone:'',
        companyName:'',
        disName:'',
        idcard:'',
        userName:''
      }
    },
    agreementClose(){
      if(this.status=='1'){
        this.form.sms_flag = '2'
      }
      this.agreement = false
    },
    SMSch(e){
      if(this.form.third_system=='其他'){
        this.agreement = false
        return false
      }else{
        if(this.form.Name==''){
          this.form.sms_flag = '2'
          Message.error('请先输入分销商简称')
          return false
        }
        if(this.form.sms_flag=='1'){
          this.agreement = true
        }
      }
    },
    smsChange(e){
      if(this.form.Name==''){
        Message.error('请先输入分销商简称')
        return false
      }
      this.form.sms_flag = e
      this.agreement = true
      this.$forceUpdate()
    },
    slectClick(e){
      if(e!='其他'){
          this.retailFlow = false
          this.form.refund_sms_flag = '2'
          this.form.sms_flag = '2'
      }else{
        this.retailFlow = true
        this.form.refund_sms_flag = '1'
        this.form.sms_flag = '1'
      }
    },
    clearBox(){
      this.dianji = false
      this.form={
        Name:'', // 分销商名称
        FullName:'',//分销商全称
        ProID:'',//省id
        CityID:'',// 市id
        ZoneID:'', // 县id
        Address:'', // 地址
        LinkMan:'', // 联系人
        Phone:'', // 手机号
        E_Mail:"",
        OverDraftMoney:'',//透支金额
        Status:'',
        sms_flag:'1',
        refund_sms_flag:'1',
        third_system:'其他'
      }
    },
    // 添加分销商
    saveBtns(form){
      this.form.token =  window.sessionStorage.getItem('Token')
      this.$refs[form].validate((valid) =>{
        if(valid){
          if(this.addRetailvisibleId){
            this.form.Disid = this.addRetailvisibleId
            this.form.phone = this.form.Phone
            this.form.name = this.form.Name
            if(this.dianji){
              return false
            }else{
              this.dianji = true
            }
            DisSetPhone(this.form).then(res=>{
              if(res.data.rcode==200){
                this.dianji = false
                Message.success('修改分销商成功')
                this.defailDialogVisible = false;
                this.$emit('defail')
              }else{
                this.dianji = false
                Message.error(res.data.msg)
              }
            })
          }else{
            if(this.dianji){
              return false
            }else{
              this.dianji = true
            }
            addDistributor(this.form).then(res=>{
              if(res.data.rcode==200){
                this.dianji = false
                Message.success('添加分销商成功')
                this.defailDialogVisible = false;
                this.$emit('defail')
              }else{
                this.dianji = false
                Message.error(res.data.msg)
              }
            })
          }
          
        }
      })
      
    },
      // 选中省
    provinceChange(e) {
      this.cityProvince.forEach((item, index) => {
        if (e == item.provinceCode) {
          this.form.CityID = ''
          this.form.ZoneID = ''
          this.cityDistrict = item.cities;
        }
      });
    },
    // 选中市
    cityChange(e) {
      this.cityDistrict.forEach((item, index) => {
        if (e == item.cityCode) {
          this.form.ZoneID = ''
          this.cityCounty = item.counties;
        }
      });
    },
    // 详情弹框
    addRetail(row) {
      if (row) {
        this.editTitle = "分销商详情";
      } else {
        this.editTitle = "添加分销商";
      }
      this.dianji = false
      this.defailDialogVisible = true;
    },
    // 详情X
    defailHandleClose() {
      this.defailDialogVisible = false;
      this.addRetailvisibleId = ''
      this.$emit('defail')
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-form-item {
  position: relative;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -94px;
  color: #e74c3c;
}
.absPosiB {
  position: absolute;
  top: 0px;
  left: -94px;
  color: #e74c3c;
}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #e74c3c;
}
.absPosiF {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #e74c3c;
}

.absPosiH {
  position: absolute;
  top: 0px;
  left: -59px;
  color: #e74c3c;
}
.absPosiI {
  position: absolute;
  top: 0px;
  left: -106px;
  color: #e74c3c;
}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -50px;
  color: #e74c3c;
}
.absPosiJ {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #e74c3c;
}
.editForm {
  /deep/.el-form-item__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  .endItem {
    .el-input {
      width: 240px;
    }
    .dW {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-left: 10px;
    }
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-left: -100px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    /deep/.el-form-item__content {
      margin-left: 0px;
    }
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #246deb;
    }
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    /deep/.el-select {
      width: 190px;
      height: 40px;
      margin-right: 20px;
      .el-input {
        width: 190px;
        height: 100%;
      }
    }

  }
  .itemMoble {
    .el-form-item {
      margin-right: 27px;
    }
    /deep/.el-input {
      width: 240px;
      height: 40px;
    }
  }

  .itemInp {
    // width: 500px;
    .el-form-item {
      // display: flex;
      // margin-right: 45px;
      /deep/.el-input {
        // width: 240px;
        height: 40px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.flexDis{
  flex-wrap: wrap;
}
/deep/ .el-dialog{
  min-width: 400px;
}
@media only screen and (max-width: 1760px) {
    .itemSele{
      /deep/ .el-select{
        margin-bottom: 10px;
      }
    }
}
.itemBtnS /deep/.el-form-item__content{
  display: flex;
}
.itm_btns_clear{
  width: 10rem;
  height: 4rem;
  background: #D9D9D9;
  color: #ffffff;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 2rem;
  cursor: pointer;
}
/deep/ .el-input input{
  background: #FFF !important;
}
.xitong{
  ::v-deep .el-select{
    width: 100%;
  }
}
.sms_flages{
  ::v-deep .el-radio-group{
    display: flex;
    align-items: center;
  }
  ::v-deep .el-radio{
    &:nth-child(2){
      margin-right: 1rem !important;
    }
  }
}
.smsFlag_btns{
  padding: 0 2rem;
  height: 4rem;
  border-radius: 0.4rem;
  border: 1px solid #246deb;
  color: #246deb;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1.4rem;
}
.content_css{
  margin-top: 3.8rem;
  div{
    color: #000000;
    font-size: 1.4rem;
    &:nth-child(3){
      margin-top: 1.5rem;
    }
    &:nth-child(4){
      margin-top: 1.5rem;
    }
    &:nth-child(n+3){
      text-indent: 2em;
    }
    &:last-child{
      text-indent:7em;
    }
  }
}
.content_info{
  margin-top:5rem;
  padding: 3.9rem 0 0 0;
  box-sizing: border-box;
  border-top: 1px solid #E5E5EA;
  .itemMoble{
    ::v-deep .el-input{
      width: 33rem;
    }
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.active_raido{
  border: none !important;
  margin-bottom: 3px;
}

</style>